import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/MyAddresses/MyAddresses.js
const MyAddresses = createSectionForm({
  icon: "map-pin-user-line",
  title: "My Addresses",
  fields: [{ name: "title", label: "Heading", placeholder: "My Addresses" }],
});

export default MyAddresses;
